import { Box, Stack } from "@mui/material";
import Image from "next/image";
import React from "react";
import { Infinity } from "ldrs/react";
//@ts-ignore
import "ldrs/react/Infinity.css";
export default function LogoLoading() {
  return (
    <Stack
      sx={{
        flexDirection: "column",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        position: "relative",
      }}
    >
      <Box sx={{ position: "relative", height: 50, width: 180 }}>
        <Image src="/logo.svg" alt="ZibasiLogoLoading" fill={true} style={{ objectFit: "contain" }} />
      </Box>
      <Box dir={"ltr"}>
        <Infinity size="55" stroke="4" stroke-length="0.15" bg-opacity="0.35" speed="1.4" color="#FFD7B3"/>
      </Box>
    </Stack>
  );
}
